import { useEffect } from "react";

import { useFireAnalyticsEvents } from "@/components/fastshift/analytics";

import { useResourcesPageAnalyticsData } from "./use-resources-page-analytics-data";

export const useResourcesPageAnalytics = (isDomainScoped: boolean) => {
    const { sourceKey, identityAttrs } =
        useResourcesPageAnalyticsData(isDomainScoped);
    const { fireScreenEvent } = useFireAnalyticsEvents(identityAttrs);

    useEffect(() => {
        if (!identityAttrs) {
            return;
        }

        fireScreenEvent({
            name: sourceKey,
            attributes: identityAttrs
        });
    }, [fireScreenEvent, identityAttrs, sourceKey]);
};
